import $ from "jquery";

export function pagePreventLeave() {
  /*
   * Function that prevent user from refresh page or leave page
   */
  window.onbeforeunload = function () {
    return "Are you sure you want to leave?";
  };
}

export function pageLeave() {
  /*
   * Function that allows user from refresh page or leave page
   */
  window.onbeforeunload = null;
}

export function hideLoaderBar() {
  /*
   * Function that hide loader bar and show page container
   */
  setTimeout(() => {
    // time out page load
    $("#page-container").show();
    $("#loader-bar").hide();
  }, 2000);
}

export function showLoaderSpinner() {
  /*
   * Function that show loader spinner
   */

  $("#loader-spinner").fadeIn("fast");
}

export function hideLoaderSpinner() {
  /*
   * Function that hide loader spinner
   */

  $("#loader-spinner").fadeOut("slow");
}

export function getWords(str, count, separator) {
  /*
   * Function that that return words from string
   */

  return str.split(/\s+/).slice(0, count).join(separator);
}

export function formatBytes(bytes, decimals = 2) {
  /*
   * Function that return a file format size
   */

  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
}

export function randStrId() {
  /*
   * Function that return a unique string ID
   */

  return (
    "_" +
    Math.random()
      .toString(36)
      .replace(/[^a-z]+/g, "")
      .substr(2, 10)
  );
}
